import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { CompanyListModule } from '@components/company-list/company-list.module';
import { TollComponent } from './toll.component';
import { SiteListModule } from '@components/site-list/site-list.module';
import { MaterialListModule } from '@components/material-list/material-list.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    CompanyListModule,
    MaterialListModule,
    SiteListModule
  ],
  declarations: [TollComponent],
  entryComponents: [TollComponent],
})
export class TollModule { }
